// Pure helper for the "Revoked Invitations" section. Kept DOM-free so it's unit-
// testable in isolation (links.ts pulls in DOM/vendor modules).
export function effectiveRevokedAt(
  l: { revoked_at?: string | null; expires_at?: string | null },
  now: number = Date.now(),
): string | null {
  if (l.revoked_at) return l.revoked_at;
  if (l.expires_at && new Date(l.expires_at).getTime() <= now) return l.expires_at;
  return null;
}
